import PauseFillIcon from "../icons/PauseFillIcon";

import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useContext, useState } from "react";
import { ModalContext } from "@/pages/_app";
import ArrowIcon from "../icons/ArrowIcon";
import { useRouter } from "next/router";
import { handleLinkByType } from "@/helpers/common/handleLinkByType";
import { v4 as uuidv4 } from "uuid";
import Link from "next/link";
import NextImage from "../global/NextImage";
import { validateImgSrc } from "@/utils/global";

const VideoSection = ({ data }) => {
  console.log("VideoSection", data);
  const { locale } = useRouter();
  const Context = useContext(ModalContext);
  const [swiper, set_swiper] = useState({});
  return (
    data?.value?.length > 0 && (
      <section className="py-4 relative">
        <Swiper
          loop
          spaceBetween={30}
          breakpoints={{
            768: {
              slidesPerView: 1.5,
            },
          }}
          key={locale}
          dir={locale === "en" ? "ltr" : "rtl"}
          centeredSlides
          modules={[Autoplay]}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          onInit={(e) => set_swiper(e)}
        >
          {data?.value?.map((slide) => (
            <SwiperSlide key={uuidv4()}>
              <div className="relative">
                <div className="p-3 absolute top-0 z-30 left-0 h-full w-full bg-black text-white bg-opacity-40 flex items-center justify-center flex-col gap-2 sm:gap-4">
                  <h2 className="text-lg sm:text-[28px] font-extrabold text-center">
                    {slide[`title-${locale}`] || ""}
                  </h2>
                  <PauseFillIcon
                    onClick={() =>
                      slide?.video &&
                      Context?.dispatch({
                        type: "videoModal",
                        payload: {
                          videoUrl: slide?.video,
                          title: slide[`title-${locale}`] || "",
                        },
                      })
                    }
                    className="size-6 sm:size-8 cursor-pointer"
                  />
                  <Link
                    href={handleLinkByType(slide?.url, slide?.type) || "/"}
                    className="text-center bg-primary max-sm:p-1 p-3 rounded-md w-52 max-sm:w-48 font-bold text-lg max-sm:text-sm hover:opacity-95"
                  >
                    {locale === "en" ? "Shop Now" : "تسوق الآن"}
                  </Link>
                </div>
                <div className="w-full aspect-[1/0.4] relative overflow-hidden">
                  <NextImage
                    width={900}
                    height={370}
                    src={validateImgSrc(slide[`img-${locale}`])}
                    className="object-cover w-full"
                    alt="video"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <button
          onClick={() => swiper?.slidePrev()}
          className="absolute top-[calc(50%-1rem)] bg-tertiary-900 text-white size-12 max-sm:size-8 rounded-full z-30 hidden min-[420px]:flex items-center justify-center left-4"
        >
          <ArrowIcon width={12} height={12} className="rotate-180" />
        </button>
        <button
          onClick={() => swiper?.slideNext()}
          className="absolute top-[calc(50%-1rem)] bg-tertiary-900 text-white size-12 max-sm:size-8 rounded-full z-30 hidden min-[420px]:flex items-center justify-center right-4"
        >
          <ArrowIcon width={12} height={12} />
        </button>
      </section>
    )
  );
};

export default VideoSection;
